import type { FC } from 'react'
import { SvgIconProps } from '@mui/material'

import { useFestiveVariants } from '@dhl/utils'

import { ServicePointDefault } from './ServicePointDefault.js'
import { ServicePointChristmas } from './ServicePointChristmas.js'
import { ServicePointSinterklaas } from './ServicePointSinterklaas.js'
import { ServicePointEaster } from './ServicePointEaster.js'

export const ServicePoint: FC<SvgIconProps> = (props) => {
  const Component = useFestiveVariants({
    christmas: ServicePointChristmas,
    default: ServicePointDefault,
    easter: ServicePointEaster,
    sinterklaas: ServicePointSinterklaas,
  })

  return <Component {...props} />
}
